import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useGradeReportHook from "../hooks/useGradeReportHook";
import moment from "moment";

const GradeReport = ({ source }) => {
  const { data, loading, error } = useGradeReportHook(source);

  const columns = [
    {
      field: "District",
      headerName: "District",
      flex: 1,
    },
    {
      field: "High_School",
      headerName: "High School",
      flex: 1,
    },
    {
      field: "Tartan_Id",
      headerName: "Tartan",
      flex: 1,
    },
    {
      field: "SSID",
      headerName: "SSID",
      flex: 1,
    },

    {
      field: "First_Name",
      headerName: "First Name",
      flex: 1,
    },
    {
      field: "Last_Name",
      headerName: "Last Name",
      flex: 1,
    },
    {
      field: "Graduation_Year",
      headerName: "Grad Year",
      flex: 1,
    },
    {
      field: "Course",
      headerName: "Course",
      flex: 1,
    },
    {
      field: "Course_Start_Date",
      headerName: "Start Date",
      flex: 1,
    },
    {
      field: "Course_End_Date",
      headerName: "End Date",
      flex: 1,
    },
    {
      field: "Restricted",
      headerName: "Restricted",
      flex: 1,
    },
    {
      field: "Credit_Hour_Count",
      headerName: "Credit Hour Count",
      flex: 1,
    },
    {
      field: "Cumulative_GPA",
      headerName: "Cumulative GPA",
      flex: 1,
    },
    {
      field: "Term_GPA",
      headerName: "Term GPA",
      flex: 1,
    },
    {
      field: "Credit_Hrs_Earned",
      headerName: "Credit Hours Earned",
      flex: 1,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
      />
    </>
  );
};

export default GradeReport;
